import type {DimensionsSpecificationRequestBody} from './DimensionsSpecificationRequestBody';

export type DimensionsRequestBody = {
  dimensions?: DimensionsSpecificationRequestBody | null;
  /**
   * Vehicle operating weight in kg
   */
  operatingWeight?: number | null;
  /**
   * Vehicle weight in kg
   */
  weight?: number | null;
  /**
   * Vehicle maximum load capacity in kg
   */
  maximalLoadCapacity?: number | null;
  /**
   * Wheel base
   */
  wheelBase?: number | null;
  /**
   * Trunk space
   */
  trunkSpace?: number | null;
  /**
   * Loading space sizes in m
   */
  dimensionsLoadingSpace?: DimensionsSpecificationRequestBody | null;
  /**
   * Loading area in m2
   */
  loadingArea?: number | null;
  /**
   * Length category
   */
  lengthCategory?: string | null;
  /**
   * Height category
   */
  heightCategory?: string | null;
};
